<template>
    <svg
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.0002 4.40747L3.12109 9.78938V16.9998H8.64871V11.7158H11.5852V16.9998H16.8794V9.78938L10.0002 4.40747Z"
            :fill="customColor || accountButtonColor"
        />
        <path
            opacity="0.6"
            d="M17.1673 5.60595V1.91929H14.2702V3.33994L10 0L0 7.82161L1.38043 9.64601L10 2.90247L18.6196 9.64605L20 7.82165L17.1673 5.60595Z"
            :fill="customColor || accountButtonColor"
        />
    </svg>
</template>

<script setup>
    import { useAccountStore } from '~/stores/accountStore.ts';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: '',
        }
    });

    const { accountButtonColor } = useAccountStore().state;
</script>
